/* Note: This is an autogenerated file. Please DO NOT modify anything manually here. */
import * as Types from "src/generated/graph-api";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GQLHasAccessToFeatureQueryVariables = Types.Exact<{
	feature: Types.InputMaybe<Types.GQLAppFeature>;
}>;

export type GQLHasAccessToFeatureQuery = {
	__typename: "Query";
	me: {
		__typename: "IdentityMePayload";
		record: {
			__typename: "IdentityUser";
			id: string;
			hasAccessToFeature: boolean;
		} | null;
	};
};

export const HasAccessToFeatureDocument = gql`
    query HasAccessToFeature($feature: AppFeature) {
  me {
    record {
      id
      hasAccessToFeature(feature: $feature)
    }
  }
}
    `;

/**
 * __useHasAccessToFeatureQuery__
 *
 * To run a query within a React component, call `useHasAccessToFeatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasAccessToFeatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasAccessToFeatureQuery({
 *   variables: {
 *      feature: // value for 'feature'
 *   },
 * });
 */
export function useHasAccessToFeatureQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GQLHasAccessToFeatureQuery,
		GQLHasAccessToFeatureQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GQLHasAccessToFeatureQuery,
		GQLHasAccessToFeatureQueryVariables
	>(HasAccessToFeatureDocument, options);
}
export function useHasAccessToFeatureLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GQLHasAccessToFeatureQuery,
		GQLHasAccessToFeatureQueryVariables
	>,
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GQLHasAccessToFeatureQuery,
		GQLHasAccessToFeatureQueryVariables
	>(HasAccessToFeatureDocument, options);
}
// @ts-ignore
export function useHasAccessToFeatureSuspenseQuery(
	baseOptions?: Apollo.SuspenseQueryHookOptions<
		GQLHasAccessToFeatureQuery,
		GQLHasAccessToFeatureQueryVariables
	>,
): Apollo.UseSuspenseQueryResult<
	GQLHasAccessToFeatureQuery,
	GQLHasAccessToFeatureQueryVariables
>;
export function useHasAccessToFeatureSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GQLHasAccessToFeatureQuery,
				GQLHasAccessToFeatureQueryVariables
		  >,
): Apollo.UseSuspenseQueryResult<
	GQLHasAccessToFeatureQuery | undefined,
	GQLHasAccessToFeatureQueryVariables
>;
export function useHasAccessToFeatureSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GQLHasAccessToFeatureQuery,
				GQLHasAccessToFeatureQueryVariables
		  >,
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GQLHasAccessToFeatureQuery,
		GQLHasAccessToFeatureQueryVariables
	>(HasAccessToFeatureDocument, options);
}
export type HasAccessToFeatureQueryHookResult = ReturnType<
	typeof useHasAccessToFeatureQuery
>;
export type HasAccessToFeatureLazyQueryHookResult = ReturnType<
	typeof useHasAccessToFeatureLazyQuery
>;
export type HasAccessToFeatureSuspenseQueryHookResult = ReturnType<
	typeof useHasAccessToFeatureSuspenseQuery
>;
export type HasAccessToFeatureQueryResult = Apollo.QueryResult<
	GQLHasAccessToFeatureQuery,
	GQLHasAccessToFeatureQueryVariables
>;
